import React, { useState, useEffect } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Button,
  Box,
  Typography
} from '@mui/material';

const EnlacesModal = ({ 
  open, 
  onClose, 
  enlaces, 
  onSave 
}) => {
  const [enlacePPT, setEnlacePPT] = useState('');
  const [enlaceConfluence, setEnlaceConfluence] = useState('');
  const [enlacePDF, setEnlacePDF] = useState('');

  useEffect(() => {
    if (open && enlaces) {
      setEnlacePPT(enlaces.enlace_al_documento_ppt_sharepoint || '');
      setEnlaceConfluence(enlaces.enlace_a_la_pagina_de_confluence || '');
      setEnlacePDF(enlaces.enlace_propuesta_pdf_sharepoint || '');
    }
  }, [open, enlaces]);

  const handleSave = () => {
    onSave({
      enlace_al_documento_ppt_sharepoint: enlacePPT || '',
      enlace_a_la_pagina_de_confluence: enlaceConfluence || '',
      enlace_propuesta_pdf_sharepoint: enlacePDF || ''
    });
    onClose();
  };

  const handleCancel = () => {
    onClose();
  };

  return (
    <Dialog 
      open={open} 
      onClose={handleCancel}
      maxWidth="sm"
      fullWidth
    >
      <DialogTitle>
        <Typography variant="h6" component="div" sx={{ fontWeight: 600 }}>
          Enlaces y Recursos
        </Typography>
        <Typography variant="body2" color="text.secondary" sx={{ mt: 0.5 }}>
          Agrega o edita los enlaces de documentación del proyecto
        </Typography>
      </DialogTitle>

      <DialogContent sx={{ pt: 2 }}>
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2.5 }}>
          <Box>
            <Typography variant="subtitle2" sx={{ mb: 1, fontWeight: 500 }}>
              📄 Documento PPT (SharePoint)
            </Typography>
            <TextField
              fullWidth
              size="small"
              type="url"
              placeholder="https://..."
              value={enlacePPT}
              onChange={(e) => setEnlacePPT(e.target.value)}
              variant="outlined"
            />
          </Box>

          <Box>
            <Typography variant="subtitle2" sx={{ mb: 1, fontWeight: 500 }}>
              📖 Página de Confluence
            </Typography>
            <TextField
              fullWidth
              size="small"
              type="url"
              placeholder="https://..."
              value={enlaceConfluence}
              onChange={(e) => setEnlaceConfluence(e.target.value)}
              variant="outlined"
            />
          </Box>

          <Box>
            <Typography variant="subtitle2" sx={{ mb: 1, fontWeight: 500 }}>
              📋 Propuesta PDF (SharePoint)
            </Typography>
            <TextField
              fullWidth
              size="small"
              type="url"
              placeholder="https://..."
              value={enlacePDF}
              onChange={(e) => setEnlacePDF(e.target.value)}
              variant="outlined"
            />
          </Box>
        </Box>
      </DialogContent>

      <DialogActions sx={{ px: 3, pb: 2 }}>
        <Button 
          onClick={handleCancel} 
          color="inherit"
          variant="outlined"
        >
          Cancelar
        </Button>
        <Button 
          onClick={handleSave}
          variant="contained"
          sx={{
            backgroundColor: '#0078d4',
            '&:hover': {
              backgroundColor: '#106ebe'
            }
          }}
        >
          Guardar Enlaces
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default EnlacesModal;
